<div nz-row>
  <div
    *ngFor="let fieldKey of fieldGroupKeys" class="section-fields"
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="24"
    [nzLg]="{
      span: fieldKey | getSpanVal,
      push: fieldKey | getPushVal: [fieldGroupCount] ,
      pull: fieldKey | getPullVal: [fieldGroupCount, thereIsCenter]
    }"
    [nzXl]="{
      span: fieldKey | getSpanVal,
      push: fieldKey | getPushVal: [fieldGroupCount],
      pull: fieldKey | getPullVal: [fieldGroupCount, thereIsCenter]
    }"
  >
    <div *ngFor="let field of fieldGroups[fieldKey]">
      <app-field
        [moduleStructure]="moduleStructure"
        [field]="field"
        [recordModel]="recordModel"
        [section]="section"
        [actionType]="actionType"
      ></app-field>
    </div>
  </div>
</div>
